import { render, staticRenderFns } from "./GenresMenu.vue?vue&type=template&id=5f841af2"
import script from "./GenresMenu.vue?vue&type=script&lang=js"
export * from "./GenresMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports